import './App.css';
import { RouterProvider } from 'react-router-dom';
import Modal from 'react-modal';
import { Flex } from '@tremor/react';
import 'react-tabs/style/react-tabs.css';
import { ClipLoader } from 'react-spinners';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { rootRoutes } from './routes/rootRoutes';
import { createSentryBrowserRouter } from './sentry/init';
import { Tooltip } from 'radix-ui';
// import { connectAuthEmulator } from 'firebase/auth';
// import { auth, db, functions } from './firebase';
// import { connectFirestoreEmulator } from 'firebase/firestore';
// import { connectFunctionsEmulator } from 'firebase/functions';

const router = createSentryBrowserRouter(rootRoutes);

Modal.setAppElement('#root');

// if (import.meta.env.DEV) {
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

const Fallback = () => (
  <Flex style={{ flex: '1 0 0' }} justifyContent="center">
    <ClipLoader color="#ba2634" speedMultiplier={0.9} size={100} />
  </Flex>
);

function App() {
  return (
    <Tooltip.Provider>
      <RouterProvider router={router} fallbackElement={<Fallback />} />
      <ToastContainer />
    </Tooltip.Provider>
  );
}

export default App;
